import React, {Component} from 'react';
import $ from 'jquery';
import ContactForm from '../view/ContactForm';
import RightSideBar from '../view/RightSideBar';
import Meta from '../model/Meta';

class Contact extends Component {

    componentDidMount(){
        $('html, body').animate({scrollTop: 0}, 300);
    }

    render(){
        const meta = {
			title: "Contact us - Contracts.ph",
			description: "Contact Contracts.ph team - support@contracts.ph"
		}
        return(
            <div className="page page-inner not-found pb-5">
                <Meta {...meta}/>
                <div className="container-fluid">
                    <div className="container p-0">
                        <div className="row">
                            <div className="col-sm-12 col-md-7">
                                <h1 className="page-title">Contact</h1>
                                <div className="page-content">
                                    <ContactForm />
                                    </div>
                            </div>
                            <div className="col-sm-12 col-md-5">
                                <RightSideBar />
                            </div>
                        </div>       
                    </div>
                </div>
            </div>
        )
    }
    
}

export default Contact;


// WEBPACK FOOTER //
// ./src/pages/Contact.js